import EvaluacionDisciplinaAdministrativaAdapter from '../adapters/EvaluacionDisciplinaAdministrativa.adapter'

export default class GetEvaluacionDisciplinaAdministrativaByIdUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute({ idPersonal, idEvaluacion }) {
    try {
      const dto = await this.#repository.getById(idPersonal, idEvaluacion)
      return EvaluacionDisciplinaAdministrativaAdapter.toDomain(dto)
    } catch (error) {
      throw new Error(`Failed to execute GetEvaluacionDisciplinaAdministrativaByIdUseCase: ${error.message}`)
    }
  }
}
